module.exports = __webpack_public_path__ + "img/sec2.2.a921c568.png";